// +----------------------------------------------------------------------
// | 时间 / 数值格式化
// +----------------------------------------------------------------------

function pad(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

/**
 * 把后端时间字符串（'2026-09-18 15:00:00' 或 ISO）转成 Date
 * Safari 不认 'YYYY-MM-DD HH:mm:ss'，统一替换成 '/'
 */
export function parseTime(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const normalized = String(value).replace(/-/g, '/').replace('T', ' ').replace(/\..*$/, '');
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * 相对时间：刚刚 / 12 分钟前 / 3 小时前 / 昨天 / 9月18日
 */
export function fromNow(value) {
  const date = parseTime(value);
  if (!date) return '';

  const diff = Date.now() - date.getTime();
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diff < minute) return '刚刚';
  if (diff < hour) return `${Math.floor(diff / minute)} 分钟前`;
  if (diff < day) return `${Math.floor(diff / hour)} 小时前`;
  if (diff < 2 * day) return '昨天';
  if (diff < 7 * day) return `${Math.floor(diff / day)} 天前`;

  const now = new Date();
  if (date.getFullYear() === now.getFullYear()) {
    return `${date.getMonth() + 1}月${date.getDate()}日`;
  }
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}

/**
 * 完整时间：2026-09-18 15:00
 */
export function formatFull(value) {
  const date = parseTime(value);
  if (!date) return '';
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

/**
 * 0.72 → 72%
 */
export function toPercent(value) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num)) return '';
  return `${Math.round(num * 100)}%`;
}

/**
 * 权重（0~1 或 0~100）→ 用于进度条宽度的百分比数字（0~100）
 */
export function weightToWidth(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;
  const normalized = num > 1 ? num : num * 100;
  return Math.max(0, Math.min(100, Math.round(normalized)));
}

/**
 * 问候语（根据当前时间，首页用）
 */
export function greeting() {
  const hour = new Date().getHours();
  if (hour < 6) return '这么晚还没睡';
  if (hour < 11) return '早上好';
  if (hour < 14) return '中午好';
  if (hour < 18) return '下午好';
  if (hour < 23) return '晚上好';
  return '夜深了';
}
